<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {Table} from 'sveltestrap'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {doShow as showAlert} from '../../#common/alert/store'
    import IconifyIcon from '@iconify/svelte'
    import sendIcon from '@iconify/icons-fa-solid/envelope'
    import {
        getTask,
        sendUserMessage,
        getProfile,
        getUserReferrals,
        setBlackListStatus,
        setSuspiciousStatus,
        saveNoteToUser,
        banAllUserReferrals
    } from 'src/components/cabinet/#services/kitsuneBot'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'

    export let id

    let messageModalOpen = false
    let selectedClientId
    let currentPage = 0
    let perPage = 25
    let maxButtons = 5
    let userProfile
    let userNote
    let banCheckbox
    let suspiciousCheckbox
    let banModalOpen = false
    let blackListReasonRu
    let blackListReasonEn
    let message

    getTask.reset()
    getProfile.send({ data: { clientId: id } })
    filter()

    $: if (userProfile === undefined && $getProfile.hasValue) {
        userProfile = $getProfile.value && JSON.parse(JSON.stringify($getProfile.value))
        userNote = userProfile.note
        banCheckbox = userProfile.blackList
        suspiciousCheckbox = userProfile.suspicious
    }

    async function sendMessage() {
        if (message !== '') {
            try {
                await sendUserMessage.request({data: {clientId: selectedClientId, message}})

                messageModalOpen = false
                message = ''

                showAlert.set({
                    status: 'success',
                    text: 'Message successfully sent!'
                })
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            }
        }
    }

    async function saveUserNoteHandler() {
        try {
            await saveNoteToUser.request({ data: {
                clientId: id,
                note: userNote
            }})
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    function banChangeHandler() {
        if (banCheckbox === true) {
            unbanUserHandler()
        } else {
            banModalOpen = true
        }
    }

    async function suspiciousChangeHandler() {
        try {
            suspiciousCheckbox = !suspiciousCheckbox

            await setSuspiciousStatus.request({data: {
                clientId: id,
                suspicious: suspiciousCheckbox
            }})

            if (suspiciousCheckbox) {
                showAlert.set({
                    status: 'success',
                    text: 'The user became a suspicious'
                })
            } else {
                showAlert.set({
                    status: 'success',
                    text: 'The user is no longer suspicious'
                })
            }

            getProfile.reset()
            getProfile.send({ data: { clientId: id } })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function banUserHandler() {
        try {
            await setBlackListStatus.request({ data: {
                clientId: id,
                blackList: true,
                blackListReasonEn,
                blackListReasonRu
            }})

            banModalOpen = false
            banCheckbox = true
            blackListReasonEn = ''
            blackListReasonRu = ''

            showAlert.set({
                status: 'success',
                text: 'User successfully banned'
            })

            getProfile.reset()
            getProfile.send({ data: { clientId: id } })
        } catch (err) {
            banModalOpen = false

            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function unbanUserHandler() {
        try {
            await setBlackListStatus.request({ data: {
                clientId: id,
                blackList: false,
                blackListReasonEn: '',
                blackListReasonRu: ''
            }})

            showAlert.set({
                status: 'success',
                text: 'User successfully unbanned'
            })

            banCheckbox = false

            getProfile.reset()
            getProfile.send({ data: { clientId: id } })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function blockAllUserReferrals() {
        try {
            await banAllUserReferrals.request({data: {clientId: id}})

            showAlert.set({
                status: 'success',
                text: 'All referrals successfully banned'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    function filter() {
        getUserReferrals.reset()
        getUserReferrals.send({data:{
            clientId: id,
            page: currentPage + 1,
            perPage: perPage
        }})
    }

    $:currentPage,perPage,filter()
</script>

<svelte:head>
    <title>Profile {id}</title>
</svelte:head>

<MainLayout title="Profile {id}">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="k-tasks" class="btn btn-primary mb-3">Back</Link>
                <div class="row">
                    <div class="col-md-6">
                        <div class="tasks-list">
                            <p>Profile info</p>
                            <div class="mb-2">
                                {#if $getProfile.hasValue && $getProfile.value && $getProfile.value.blackList}
                                    <span class="badge badge-banned">Banned</span>
                                {/if}
                                {#if $getProfile.hasValue && $getProfile.value && $getProfile.value.suspicious}
                                    <span class="badge badge-suspicious">Suspicious</span>
                                {/if}
                            </div>
                            <div class="table-responsive">
                                <table class="table">
                                    <tbody>
                                        {#if !$getProfile.hasValue && $getProfile.loading}
                                            <tr>
                                                <td class="text-center" colSpan="3">Loading...</td>
                                            </tr>
                                        {:else if !$getProfile.hasValue && $getProfile.error }
                                            <tr>
                                                <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
                                            </tr>
                                        {:else if userProfile}
                                            <tr>
                                                <td><strong>Telegram ID</strong>:</td>
                                                <td>{userProfile.clientId}</td>
                                            </tr>
                                            {#if userProfile.userName}
                                            <tr>
                                                <td><strong>Username</strong>:</td>
                                                <td><a href="https://t.me/{userProfile.userName}" target="_blank">@{userProfile.userName}</a></td>
                                            </tr>
                                            {/if}
                                            {#if userProfile.firstName || userProfile.lastName}
                                                <tr>
                                                    <td><strong>Name Lastname</strong>:</td>
                                                    <td>{userProfile.firstName} {userProfile.lastName}</td>
                                                </tr>
                                            {/if}
                                            {#if userProfile.address}
                                            <tr>
                                                <td><strong>Address</strong>:</td>
                                                <td>
                                                    <a href="https://tonviewer.com/{userProfile.address}" target="_blank">
                                                        {userProfile.address}
                                                    </a>
                                                </td>
                                            </tr>
                                            {/if}
                                            <tr>
                                                <td><strong>Registered at</strong>:</td>
                                                <td>{userProfile.createdAt}</td>
                                            </tr>
                                            {#if userProfile.referredBy}
                                                <tr>
                                                <td><strong>Referrer</strong>:</td>
                                                <td><a href="/k-tasks/profile/{userProfile.referredBy}" target="_blank">{userProfile.referredBy}</a></td>
                                            </tr>
                                            {/if}
                                            <tr>
                                                <td><strong>Completed tasks</strong>:</td>
                                                <td class="orange">{userProfile.approvedTasks + userProfile.rejectedTasks}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Approved tasks</strong>:</td>
                                                <td class="green">{userProfile.approvedTasks}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Rejected tasks</strong>:</td>
                                                <td class="red">{userProfile.rejectedTasks}</td>
                                            </tr>
                                        {/if}
                                    </tbody>
                                </table>
                            </div>
                            <div class="form-group mb-3">
                                <div class="input-group">
                                    <textarea class="form-control note" bind:value={userNote}></textarea><br>
                                </div>
                                <div class="input-group">
                                    <button class="btn btn-primary" on:click={saveUserNoteHandler}>Save note</button>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group mb-3 filter">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" checked={suspiciousCheckbox} on:change|preventDefault={suspiciousChangeHandler}>
                                            User suspicious
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group mb-3 filter">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" bind:checked={banCheckbox} on:click|preventDefault={banChangeHandler}>
                                            User banned
                                        </label>
                                    </div>
                                </div>
                                <Modal bind:visible={banModalOpen} size="sm">
                                    <svelte:fragment slot="content">
                                        <div class="modal-custom__title">Ban user</div>
                                        <div class="modal-custom__text">
                                            <p>Why do you want to ban a user?</p>
                                            <textarea bind:value={blackListReasonEn} class="form-control mb-2" placeholder="Reason (EN)..." autofocus></textarea>
                                            <textarea bind:value={blackListReasonRu} class="form-control" placeholder="Reason (RU)..."></textarea>
                                        </div>
                                        <div class="modal-custom__footer">
                                            <button class="btn btn-cancel" on:click={() => { banModalOpen = false }}>Cancel</button>
                                            <button class="btn btn-primary" on:click={banUserHandler}>Ban</button>
                                        </div>
                                    </svelte:fragment>
                                </Modal>
                            </div>
                            <div class="buttons">
                                <button class="btn btn-primary" on:click={() => {
                                    selectedClientId = id
                                    messageModalOpen = true
                                }}>Send message</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="tasks-list">
                            <p>Referrals</p>
                            {#if $getUserReferrals.hasValue && $getUserReferrals.value.totalCount > 0}
                                <button class="btn btn-primary mb-3" on:click={blockAllUserReferrals}>
                                    Block all referrals
                                </button>
                            {/if}
                            {#if $getUserReferrals.hasValue}
                                <PerPage
                                    bind:perPage={perPage}
                                    disabled={$getUserReferrals.loading || $getUserReferrals.loading}
                                    totalCount={$getUserReferrals.value.totalCount}
                                />
                            {/if}
                            <Table bordered responsive>
                                <thead>
                                    <tr>
                                        <td class="text-center">№</td>
                                        <td class="text-center">User</td>
                                    </tr>
                                </thead>
                                <tbody>
                                {#if !$getUserReferrals.hasValue && $getUserReferrals.loading}
                                    <tr>
                                        <td class="text-center" colSpan="2">Loading...</td>
                                    </tr>
                                {:else if !$getUserReferrals.hasValue && $getUserReferrals.error }
                                    <tr>
                                        <td class="text-center" colspan="2">
                                            Something went wrong. Try refreshing the page.
                                        </td>
                                    </tr>
                                {:else if $getUserReferrals.value}
                                    {#if $getUserReferrals.value.totalCount > 0}
                                        {#each $getUserReferrals.value.data as {clientId, firstName, lastName, userName, blackList, suspicious}, i}
                                            <tr>
                                                <td class="text-center">{currentPage * perPage + i + 1}</td>
                                                <td class="user-column">
                                                    {#if userName}
                                                        <a href="/k-tasks/profile/{clientId}" target="_blank">
                                                            @{userName}
                                                        </a>
                                                    {:else}
                                                        <a href="/k-tasks/profile/{clientId}" target="_blank">
                                                            {firstName}{lastName ? ' ' + lastName : ''}
                                                        </a>
                                                    {/if}
                                                    {#if suspicious}
                                                        <span class="badge badge-suspicious">(suspicious)</span>
                                                    {/if}
                                                    {#if blackList}
                                                        <span class="badge badge-banned">(banned)</span>
                                                    {/if}
                                                    <button on:click={() => {
                                                        selectedClientId = clientId
                                                        messageModalOpen = true
                                                    }} class="btn send-btn" title="Send Message">
                                                        <IconifyIcon icon={sendIcon}/>
                                                    </button>
                                                </td>
                                            </tr>
                                        {/each}
                                    {:else}
                                        <tr>
                                            <td class="text-center" colspan="2">No referrals</td>
                                        </tr>
                                    {/if}
                                {/if}
                                </tbody>
                            </Table>
                            {#if $getUserReferrals.hasValue}
                                <div class="d-table">
                                    <Pagination
                                        bind:currentPage={currentPage}
                                        totalCount={$getUserReferrals.value.totalCount}
                                        perPage={perPage}
                                        {maxButtons}
                                        disabled={$getUserReferrals.loading || $getUserReferrals.loading}
                                    />
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal bind:visible={messageModalOpen}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Send private message</div>
                <div class="modal-custom__text">
                    <label>Message:</label>
                    <textarea class="form-control" placeholder="Enter message text..." bind:value={message}></textarea>
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { messageModalOpen = false }}>Close</button>
                    <button class="btn btn-primary" on:click={sendMessage} disabled={!message}>Send</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .send-btn {
        padding: 5px;
        color: #29a2da;
        line-height: 1;
        box-shadow: none;
        font-size: 18px;
    }

    .orange {
        color: #ff5d1c;
    }

    .green {
        color: #4caf50;
    }

    .red {
        color: #f44336;
    }

    .note {
        max-width: 400px;
        background: #fffdca;
        margin: 20px 0;
        min-height: 110px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        border: 0;
        font-size: 15px;
        line-height: normal;
        border-radius: 0;
        transition: .5s;
    }

    .note:hover {
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
    }

    .badge {
        display: inline-block;
        padding: .5em .8em;
        font-size: .75em;
        font-weight: 500;
        line-height: 1;
        color: white;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        margin-right: 6px;
        cursor: default;
    }

    .badge-banned {
        background: #da2e20;
    }

    .badge-suspicious {
        background: #e97624;
    }

    .modal-custom__text {
        white-space: normal !important;
    }

    .tasks-list :global(table) {
        width: auto;
    }

    .tasks-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 10px;
        line-height: normal;
    }

    .user-column {
        display: flex;
        align-items: center;
    }
</style>
